import { ICalculator, ICartCheckout, ICheckoutDependencies } from '../types';
import { defaultBranch } from 'src/constants/branches';
import { defaultCoordinates } from 'src/constants/map';
import { appStore } from 'src/mobx/appStore';
import { IBranch } from 'src/types/branches';
import { hash } from 'src/utils/formatter';
import { getDeliveryType } from 'src/utils/helpers';
import { PROMOCODE_PROVIDE_AS } from '~/view/screens/MarketingScreen/screens/PromocodesScreen/types/promocodes';

export enum ORDER_EDIT_STAGE {
  DETAILS,
  PRODUCTS,
  CHECKOUT,
}

export const defaultCheckoutDependencies: ICheckoutDependencies = {
  order: undefined,
  location: {
    address: 'PM6F+V9 Al Olaya Riyadh',
    area_id: 506,
    customer_location_id: undefined,
    lat: defaultCoordinates.lat,
    lng: defaultCoordinates.lng,
  },
  refund_reason: undefined,
  branch: defaultBranch,
  customer: undefined,
  user: {
    id: 0,
    email: '',
    name: '',
    phone: `${appStore.settings?.default_country_code || ''}`,
  },
  curbside: {
    car_brand: '',
    car_color: '',
    car_type: '',
    car_number: '',
  },
  stranger: {
    id: 0,
    name: '',
    phone: `${appStore.settings?.default_country_code || ''}`,
  },
  emenu: {
    data: undefined,
    loading: false,
  },
  dinein: {
    dinein_delivery_type: undefined,
    section: {
      id: 0,
      name: '',
    },
    table: {
      id: 0,
      name: '',
    },
  },
  products: [],
  cashback_warnings_as_errors: 1,
  previous_branch_id: 0,
  previous_order_type: '',
};

export const defaultCalculator: ICalculator = {
  loading: false,
  total: 0,
  subtotal: 0,
  earn_points: 0,
  redeem_points: 0,
  discount_amount: 0,
  discount_error: undefined,
  discounted_total: 0,
  discounted_subtotal: 0,
  left_to_free_delivery: 0,
  is_free_delivery: 0,
  delivery_type: 0,
  taxable_delivery_fee: 0,
  min_order: 0,
  free_delivery: 0,
  left_to_min_order: 0,
  max_cash_payment: 0,
  delivery_fee: 0,
  vat: 0,
  promocode: '',
  available_wallet_discount: 0,
  wallet_discount: 0,
  message: '',
  donation_subtotal: 0,
  cashback: {
    id: 0,
    amount: 0,
    maximum: 0,
    name: null,
    description: null,
    percent: 0,
    warning: '',
    warning_code: 0,
  },
  promo_code: {
    provide_as: PROMOCODE_PROVIDE_AS.DISCOUNT,
    name: '',
  },
};

export const defaultCheckoutParams = (branch?: IBranch): ICartCheckout => ({
  loading: false,
  delivery_type: getDeliveryType(branch?.delivery_type),
  promocode: '',
  payment_type: 0,
  is_curbside: 0,
  is_dinein: 0,
  send_sms_with_geo: 0,
  hash: hash(`${Date.now()}`),
  is_donation: false,
  is_order_for_someone_else: 0,
  should_contact_by_driver: false,
  card: undefined,
  selected_card: null,
  use_wallet: 0,
  notes: '',
  preorder: 0,
  preorder_date: new Date(),
});
